
let config = {
    //"baseUri": "https://formbuilder.loc/"
    "baseUri": ""
};

export default config;